import { render } from "./SizeGuide.vue?vue&type=template&id=0361ca4e&scoped=true"
import script from "./SizeGuide.vue?vue&type=script&lang=js"
export * from "./SizeGuide.vue?vue&type=script&lang=js"

import "./SizeGuide.vue?vue&type=style&index=0&id=0361ca4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0361ca4e"]])

export default __exports__